(function(){
  'use strict';

  function init(){
    var box=document.getElementById('CWProductZoom');
    if(!box) return;

    var zoomImage=box.querySelector('.cw-product-zoom__image');
    var closeButton=box.querySelector('.cw-product-zoom__close');
    var stage=box.querySelector('.cw-product-zoom__stage');
    var lastOpen=0;

    var excluded=[
      '#NavDrawer','header','nav','.site-header','.header','.drawer','.meganav','[role="navigation"]',
      'footer','#jsCrosssell','.modal','.product-single__thumbnails','.product-single__thumbnail-item',
      '.cw-thumbs','[data-cw-thumbs]','.cw-gift-hero__thumbs','.cw-gift-hero__next','.cw-past-editions__thumbs',
      '.stamped-container','.stamped-widget','.stamped-main-widget','.product-recommendations',
      '.recently-viewed','.cardraw','.js-mini-cart','.product-card','.grid-product','.product-grid-item'
    ].join(',');

    var mainImageSelectors=[
      'img.product-main-image',
      '.cw-edge-main-img',
      '.product-single__photo img',
      '.product__photo-wrapper img',
      '.cw-gift-hero__main-img',
      '.cw-past-editions__main-image',
      '[data-cw-main] img.cw-main-media',
      'main img[class*="__main-img"]',
      'main img[class*="__main-image"]'
    ].join(',');

    var mainContainers=[
      '.product__photo-wrapper',
      '.cw-edge-main',
      '.product-single__photo',
      '.cw-gift-hero__main',
      '.cw-past-editions__image-shell',
      '[data-cw-main]'
    ].join(',');

    function cleanUrl(src){
      if(!src) return '';
      try{
        var u=new URL(src,window.location.href);
        u.searchParams.delete('width');
        return u.toString();
      }catch(e){return src;}
    }

    function visible(img){
      if(!img) return false;
      var rect=img.getBoundingClientRect();
      if(rect.width<180||rect.height<180) return false;
      var style=window.getComputedStyle(img);
      return style.display!=='none'&&style.visibility!=='hidden'&&parseFloat(style.opacity||'1')>=0.05;
    }

    function candidateFromTarget(target){
      if(!target||!target.closest) return null;
      if(target.closest(excluded)) return null;

      // Gallery arrows change photos; zoom only opens on media clicks.
      if(target.closest('button, [role="button"], .slick-arrow, .swiper-button-next, .swiper-button-prev, .flickity-prev-next-button, .splide__arrow, .product-single__photo-arrow, .product__photo-arrow, [data-gallery-next], [data-gallery-prev], [data-cw-next], [data-cw-prev]')) return null;

      // Subscription box has its own dedicated lightbox and should keep using it.
      if(target.closest('[id^="cw-box-hero-"]')) return null;

      var img=target.closest('img');
      if(img&&img.matches(mainImageSelectors)&&visible(img)) return img;

      // Badges can sit on top of the image. Resolve only inside the same media container,
      // never by coordinates, so drawers/menus cannot accidentally open a photo underneath.
      var container=target.closest(mainContainers);
      if(container){
        img=container.querySelector(mainImageSelectors);
        if(img&&visible(img)) return img;
      }

      return null;
    }

    function sourceFor(img){
      if(!img) return '';

      var gift=img.closest('[id^="cw-gift-hero-"]');
      if(gift){
        var giftActive=gift.querySelector('.cw-gift-hero__thumb.is-active[data-full]');
        if(giftActive) return cleanUrl(giftActive.getAttribute('data-full'));
      }

      var past=img.closest('[id^="CW-PastEditions-"]');
      if(past){
        var pastActive=past.querySelector('[data-cw-thumb].is-active[data-full-image]');
        if(pastActive) return cleanUrl(pastActive.getAttribute('data-full-image'));
      }

      var link=img.closest('a[href]');
      if(link){
        var href=link.getAttribute('href')||'';
        if(/\.(jpe?g|png|webp|gif|avif)(\?|$)/i.test(href)||href.indexOf('cdn.shopify.com')!==-1){
          return cleanUrl(href);
        }
      }

      return cleanUrl(
        img.getAttribute('data-full-image')||
        img.getAttribute('data-full')||
        img.getAttribute('data-phototview')||
        img.currentSrc||
        img.getAttribute('src')||
        img.getAttribute('data-src')||
        ''
      );
    }

    function open(img){
      var src=sourceFor(img);
      if(!src||!zoomImage) return false;

      zoomImage.src=src;
      zoomImage.alt=img.alt||'';
      box.classList.add('is-open');
      box.setAttribute('aria-hidden','false');
      document.documentElement.classList.add('cw-product-zoom-open');
      document.body.classList.add('cw-product-zoom-open');
      lastOpen=Date.now();

      try{ if(closeButton) closeButton.focus({preventScroll:true}); }catch(e){}
      return true;
    }

    function close(){
      if(!box.classList.contains('is-open')) return;
      box.classList.remove('is-open');
      box.setAttribute('aria-hidden','true');
      document.documentElement.classList.remove('cw-product-zoom-open');
      document.body.classList.remove('cw-product-zoom-open');
      if(zoomImage){zoomImage.removeAttribute('src');zoomImage.alt='';}
    }

    function handleOpen(e){
      if(box.classList.contains('is-open')) return;
      if(Date.now()-lastOpen<500) return;

      var img=candidateFromTarget(e.target);
      if(!img) return;

      if(open(img)){
        e.preventDefault();
        e.stopPropagation();
        if(e.stopImmediatePropagation) e.stopImmediatePropagation();
      }
    }

    document.addEventListener('click',handleOpen,true);

    if(closeButton) closeButton.addEventListener('click',function(e){
      e.preventDefault();
      e.stopPropagation();
      close();
    });

    if(stage) stage.addEventListener('click',function(e){
      if(e.target===stage) close();
    });

    box.addEventListener('click',function(e){
      if(e.target===box) close();
    });

    document.addEventListener('keydown',function(e){
      if(e.key==='Escape') close();
    });
  }

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();
})();